const Save = (key, value) => {
    // Set the cookie directly - browser will handle adding/updating it
    document.cookie = `${key}=${value}; path=/`;
}

const Get = (key) => {
    var _cookies = document.cookie.split(';');

    for(var i = 0; i < _cookies.length; i++) {
        var _cookie = _cookies[i].trim().split('=');

        if(_cookie[0] === key) {
            return _cookie[1];
        }
    }

    return null;
}

const Delete = (key) => {
    // Check if the cookie exists
    if (Get(key) !== null) {
        // Set the cookie with an expired date to delete it
        document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
        return true;
    }

    return false;
}

const exportData = { Save, Get, Delete };

export default exportData;